import styles from './styles.module.scss';

const FieldsSensorMarker = ({ name = '' }) => {
  return (
    <div className={styles.markerSensor}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 9H5m3 0v3m0-3h7m-7 9h2m-2 0H5m3 0v-6m-5 6h2m0 0V9m0 0H1V5.2c0-1.1201 0-1.68016.21799-2.10798.19174-.37633.4977-.68229.87403-.87403C2.51984 2 3.0799 2 4.2 2h11.6c1.1201 0 1.6802 0 2.108.21799.3763.19174.6823.4977.874.87403C19 3.51984 19 4.07989 19 5.2V9h-4m-7 3 7 1V9"></path></svg>
      <div className={styles.markerSensorText}>{name}</div>
    </div>
  );
};

export default FieldsSensorMarker;
